import { Box, styled } from '@mui/material';

import { CollapseIcon, ExpandIcon } from '../../../icons';
import { Button } from '../../atoms/Button';
import { type HTMLDisplayProps, useHTMLDisplay } from './useHTMLDisplay';

type Props = HTMLDisplayProps;

const ContentContainer = styled(Box)(({ theme }) => ({
  wordBreak: 'break-word',
  '& ul': {
    listStyleType: 'disc !important',
    paddingLeft: theme.spacing(2.5),
    margin: theme.spacing(0.5, 0),
  },
  '& ol': {
    listStyleType: 'decimal !important',
    paddingLeft: theme.spacing(2.5),
    margin: theme.spacing(0.5, 0),
  },
  '& h1': {
    fontWeight: 700,
    fontSize: '1.5rem',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
  },
  '& h2': {
    fontWeight: 700,
    fontSize: '1.25rem',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
  },
  '& h3': {
    fontWeight: 700,
    fontSize: '1rem',
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
  },
  '& h4': {
    fontWeight: 700,
    fontSize: '0.875rem',
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
  },
  '& p': {
    margin: 0,
  },
  '& a': {
    color: theme.palette.primary.main,
    textDecoration: 'underline',
  },
}));

export function HTMLDisplay(props: Props) {
  const hook = useHTMLDisplay(props);

  return (
    <Box data-testid={props['data-testid']}>
      <ContentContainer
        ref={hook.contentRef}
        sx={hook.lineClampStyle}
      >
        {hook.parsedContent}
      </ContentContainer>

      {hook.showButton && props.maxLines ? (
        <Box sx={{ textAlign: 'center', mt: 1 }}>
          <Button
            size="small"
            variant="outlined"
            onClick={hook.handleToggleExpanded}
            endIcon={hook.isExpanded ? <CollapseIcon fontSize="small" /> : <ExpandIcon fontSize="small" />}
          >
            {hook.isExpanded ? 'Voir moins' : 'Voir plus'}
          </Button>
        </Box>
      ) : null}
    </Box>
  );
}

export { HTMLDisplay as HtmlDisplay };
export type { HTMLDisplayProps };
